import { ReactComponent as CsvIcon } from './csv-icon.svg'
import { ReactComponent as DocIcon } from './doc-icon.svg'
import { ReactComponent as DocxIcon } from './docx-icon.svg'
import { ReactComponent as JpgIcon } from './jpg-icon.svg'
import { ReactComponent as PdfIcon } from './pdf-icon.svg'
import { ReactComponent as PngIcon } from './png-icon.svg'
import { ReactComponent as PptIcon } from './ppt-icon.svg'
import { ReactComponent as PptxIcon } from './pptx-icon.svg'
import { ReactComponent as XslIcon } from './xls-icon.svg'
import { ReactComponent as XlsxIcon } from './xlsx-icon.svg'
import { ReactComponent as DefaultIcon } from './default-icon.svg'

export const getDocTypeIcon = (fileType) => {
  switch (fileType) {
    case 'xls':
      return <XslIcon />;
    case 'xlsx':
    case 'xlsm':
      return <XlsxIcon />;
    case 'pdf':
      return <PdfIcon />;
    case 'ppt':
      return <PptIcon />;
    case 'pptx':
      return <PptxIcon />;
    case 'doc':
      return <DocIcon />;
    case 'docx':
      return <DocxIcon />;
    case 'csv':
      return <CsvIcon />;
    case 'jpg':
    case 'jpeg':
      return <JpgIcon />;
    case 'png':
      return <PngIcon />;
    default:
      return <DefaultIcon />;
  }
}